import React, { useEffect } from "react";
import TransferenciasCuentasPropiasHeader from "./TransferenciasCuentasPropiasHeader";
import {
  Container,
  Header,
  Form,
  Button,
  Label,
  Grid,
  Icon,
} from "semantic-ui-react";
import { useState } from "react";
import {
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_INICIAL,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_VALIDACION,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_PROCESADO,
  LONGITUD_MAXIMA_IMPORTE,
} from "../../../../app/infrastructure/appConstants";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import {
  getCuentasOperaciones,
  getCuentasDeposito,
} from "../../../../app/store/actions/cuentaActions";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import {
  transferenciaCuentasPropiasValidar,
  transferenciaCuentasPropiasConfirmar,
} from "../../../../app/store/actions/transferenciaActions";
import { createOptionsCuentaTransferencias } from "../../../../app/util/optionsUtils";
import { connect } from "react-redux";
import { Form as FinalForm, Field } from "react-final-form";
import { combineValidators, composeValidators, isRequired } from "revalidate";
import {
  isCuentaDestinoDiferente,
  //isEqualValue,
  isGreaterThanOrEqual,
  //isLessThanOrEqual,
} from "../../../../app/util/revalidateUtils";
import { tipoMonedaOptions } from "../../../../app/config/data/options";
import NumberInput from "../../../../app/common/form/NumberInput";
import PropTypes from "prop-types";
import TransferenciasCuentasPropiasResumen from "./TransferenciasCuentasPropiasResumen";
import { Link } from "react-router-dom";
import {
  MESSAGE_TRANSFERENCIA_CUENTA_ORIGEN,
  MESSAGE_TRANSFERENCIA_CUENTA_DESTINO,
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
} from "../../../../app/util/messageUtils";
import DisponibilidadOperacionesMessage from "../../../../app/common/messages/DisponibilidadOperacionesMessage";
import { resetScroll } from "../../../../app/util/JsUtils";

const actions = {
  getCuentasOperaciones,
  getCuentasDeposito,
  verificarDisponibilidadPago,
  transferenciaCuentasPropiasValidar,
  transferenciaCuentasPropiasConfirmar,
};
const mapState = (state) => ({
  cuentasOperaciones: state.cuentaReducer.cuentasOperaciones,
  loadingCuentasOperaciones: state.cuentaReducer.loadingCuentasOperaciones,
  cuentasDeposito: state.cuentaReducer.cuentasDeposito,
  loadingCuentasDeposito: state.cuentaReducer.loadingCuentasDeposito,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  loadingTransferenciaCuentasPropiasValidar:
    state.transferenciaReducer.loadingTransferenciaCuentasPropiasValidar,
  loadingTransferenciaCuentasPropiasConfirmar:
    state.transferenciaReducer.loadingTransferenciaCuentasPropiasConfirmar,
});

const TransferenciasCuentasPropiasPage = ({
  cuentasOperaciones,
  loadingCuentasOperaciones,
  getCuentasOperaciones,
  cuentasDeposito,
  loadingCuentasDeposito,
  getCuentasDeposito,
  currentUser,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  transferenciaCuentasPropiasValidar,
  transferenciaCuentasPropiasConfirmar,
  loadingTransferenciaCuentasPropiasValidar,
  loadingTransferenciaCuentasPropiasConfirmar,
}) => {
  //effects
  useEffect(() => {
    if (currentUser?.username) {
      getCuentasOperaciones();
    }
  }, [getCuentasOperaciones, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      getCuentasDeposito();
    }
  }, [getCuentasDeposito, currentUser]);

  //states
  const [
    faseTransferenciaCuentasPropias,
    setFaseTransferenciaCuentasPropias,
  ] = useState(FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_INICIAL);
  const [cuentaOrigen, setCuentaOrigen] = useState(null);
  const [codigoMonedaCuentaOrigen, setCodigoMonedaCuentaOrigen] = useState(
    null
  );
  // const [
  //   saldoDisponibleCuentaOrigen,
  //   setSaldoDisponibleCuentaOrigen,
  // ] = useState(null);
  const [cuentaDestino, setCuentaDestino] = useState(null);
  const [codigoMonedaCuentaDestino, setCodigoMonedaCuentaDestino] = useState(
    null
  );
  const [codigoMoneda, setCodigoMoneda] = useState(null);
  const [importeTransferencia, setImporteTransferencia] = useState(null);
  const [aplicaTipoCambio, setAplicaTipoCambio] = useState(false);
  const [importeValidado, setImporteValidado] = useState(null);
  const [itfValidado, setItfValidado] = useState(null);
  const [tipoCambioValidado, setTipoCambioValidado] = useState(null);
  //Options
  const cuentasOperacionesOptions = createOptionsCuentaTransferencias(
    cuentasOperaciones
  );
  const cuentasDepositoOptions = createOptionsCuentaTransferencias(
    cuentasDeposito
  );
  const [importeTransferirValidado, setImporteTransferirValidado] = useState(
    null
  );
  const [monedaTransferirValidado, setMonedaTransferirValidado] = useState(
    null
  );
  const [importeDebitarValidado, setImporteDebitarValidado] = useState(null);
  const [monedaDebitarValidado, setMonedaDebitarValidado] = useState(null);
  //validates
  const validate = combineValidators({
    cuentaRetiro: composeValidators(
      isRequired({ message: "Debe seleccionar la cuenta origen" })
    )(),
    cuentaDeposito: composeValidators(
      isRequired({ message: "Debe seleccionar la cuenta destino" }),
      isCuentaDestinoDiferente(cuentaOrigen)({
        message: `La cuenta destino tiene que ser diferente a la cuenta origen.`,
      })
      // isEqualValue(
      //   codigoMonedaCuentaOrigen,
      //   codigoMonedaCuentaDestino
      // )({
      //   message: `La cuenta de origen y destino deben ser de la misma moneda.`,
      // })
    )(),
    codigoMoneda: composeValidators(
      isRequired({ message: "Debe seleccionar la moneda" })
    )(),
    importe: composeValidators(
      isRequired({ message: "Importe es requerido" }),
      isGreaterThanOrEqual(1)({
        message: `El importe tiene que ser mayor a 0`,
      })
      // isLessThanOrEqual(saldoDisponibleCuentaOrigen)({
      //   message: `El importe es mayor al saldo disponible de la cuenta origen.`,
      // })
    )(),
  });

  //business logic
  //Metodo que permite validar la transferencia
  const submitContinuar = async (values) => {
    //Verificando disponibilidad de pago
    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      //si las cuentas tienen distintos tipo de moneda => aplica tipo de cambio
      setAplicaTipoCambio(
        codigoMonedaCuentaOrigen !== codigoMonedaCuentaDestino
      );

      const responseValidacion = await transferenciaCuentasPropiasValidar({
        ...values,
      });
      if (responseValidacion && responseValidacion.data) {
        setImporteValidado(importeTransferencia);
        setItfValidado(responseValidacion.data.itfRetiro);
        setTipoCambioValidado(responseValidacion.data.tipoCambio);
        setMonedaDebitarValidado(responseValidacion.data.codigoMonedaRetiro);
        setImporteDebitarValidado(responseValidacion.data.importeRetiro);
        setMonedaTransferirValidado(
          responseValidacion.data.codigoMonedaTransferir
        );
        setImporteTransferirValidado(responseValidacion.data.importeTransferir);
        //fase validacion
        setFaseTransferenciaCuentasPropias(
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_VALIDACION
        );
        resetScroll();
      }
    }
  };

  //Metodo que permite reiniciar algunos valores cuando se regresa en la transferencia
  const handleAtras = () => {
    setImporteValidado(null);
    setItfValidado(null);
    setTipoCambioValidado(null);
    setAplicaTipoCambio(false);
    setMonedaDebitarValidado(null);
    setImporteDebitarValidado(null);
    setMonedaTransferirValidado(null);
    setImporteTransferirValidado(null);
    //fase inicio
    setFaseTransferenciaCuentasPropias(
      FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_INICIAL
    );
  };

  const submitConfirmarTransferencia = async () => {
    const request = {
      cuentaRetiro: cuentaOrigen,
      cuentaDeposito: cuentaDestino,
      importe: importeTransferencia,
      codigoMoneda,
    };
    const responseConfirmacion = await transferenciaCuentasPropiasConfirmar(
      request
    );
    if (
      responseConfirmacion &&
      responseConfirmacion.data &&
      responseConfirmacion.data.resultado === true
    ) {
      setFaseTransferenciaCuentasPropias(
        FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_PROCESADO
      );
      resetScroll();
    }
  };

  //return
  if (loadingCuentasOperaciones)
    return <LoadingComponent content="Cargando cuentas operaciones..." />;
  if (loadingCuentasDeposito)
    return <LoadingComponent content="Cargando cuentas deposito..." />;
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingTransferenciaCuentasPropiasValidar)
    return <LoadingComponent content="Transferencia validar..." />;
  if (loadingTransferenciaCuentasPropiasConfirmar)
    return <LoadingComponent content="Transferencia confirmar..." />;
  return (
    <>
      <Container className="containerPrincipal">
        {faseTransferenciaCuentasPropias ===
        FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_INICIAL ? (
          <>
            <TransferenciasCuentasPropiasHeader />
            <FinalForm
              onSubmit={async (values) => {
                submitContinuar(values);
              }}
              initialValues={{
                cuentaRetiro: cuentaOrigen,
                cuentaDeposito: cuentaDestino,
                codigoMoneda: codigoMoneda,
                importe: importeTransferencia,
              }}
              validate={validate}
              render={({ handleSubmit, submitting, invalid }) => (
                <Form
                  onSubmit={handleSubmit}
                  error
                  style={{ marginTop: "2.5em" }}
                >
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona la cuenta origen"
                  />
                  <Field
                    name="cuentaRetiro"
                    component={SelectedInput}
                    placeholder="Selecciona la cuenta origen"
                    options={cuentasOperacionesOptions}
                    handleOnChange={(value) => {
                      setCuentaOrigen(value);
                      if (
                        value &&
                        cuentasOperaciones &&
                        cuentasOperaciones.length > 0
                      ) {
                        const cuenta = cuentasOperaciones.filter(
                          (c) => c.numeroCuenta === value
                        )[0];
                        // setSaldoDisponibleCuentaOrigen(cuenta.saldoDisponible);
                        setCodigoMonedaCuentaOrigen(cuenta.codigoMoneda);
                        if (
                          codigoMonedaCuentaDestino &&
                          codigoMonedaCuentaDestino === cuenta.codigoMoneda
                        ) {
                          setCodigoMoneda(cuenta.codigoMoneda);
                        }
                        setCodigoMoneda(cuenta.codigoMoneda);
                      }
                    }}
                  />
                  <Label color="blue" tag size="medium">
                    {MESSAGE_TRANSFERENCIA_CUENTA_ORIGEN}
                  </Label>
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona la cuenta destino"
                  />
                  <Field
                    name="cuentaDeposito"
                    component={SelectedInput}
                    placeholder="Selecciona la cuenta destino"
                    options={cuentasDepositoOptions}
                    handleOnChange={(value) => {
                      setCuentaDestino(value);
                      if (
                        value &&
                        cuentasDeposito &&
                        cuentasDeposito.length > 0
                      ) {
                        const cuenta = cuentasDeposito.filter(
                          (c) => c.numeroCuenta === value
                        )[0];
                        setCodigoMonedaCuentaDestino(cuenta.codigoMoneda);
                        if (
                          codigoMonedaCuentaOrigen &&
                          codigoMonedaCuentaOrigen === cuenta.codigoMoneda
                        ) {
                          setCodigoMoneda(cuenta.codigoMoneda);
                        }
                      }
                    }}
                  />
                  <Label color="blue" tag size="medium">
                    {MESSAGE_TRANSFERENCIA_CUENTA_DESTINO}
                  </Label>
                  <Header as="h4" color="blue" content="Selecciona la moneda" />
                  <Field
                    name="codigoMoneda"
                    component={SelectedInput}
                    placeholder="Selecciona la moneda"
                    options={tipoMonedaOptions}
                    handleOnChange={(value) => {
                      if (
                        codigoMonedaCuentaOrigen &&
                        codigoMonedaCuentaDestino &&
                        codigoMonedaCuentaOrigen === codigoMonedaCuentaDestino
                      ) {
                        setCodigoMoneda(codigoMonedaCuentaOrigen);
                      } else {
                        setCodigoMoneda(value);
                      }
                    }}
                    disabled={
                      codigoMonedaCuentaOrigen === codigoMonedaCuentaDestino
                    }
                  />
                  {codigoMonedaCuentaOrigen &&
                    codigoMonedaCuentaDestino &&
                    codigoMonedaCuentaOrigen !== codigoMonedaCuentaDestino && (
                      <Label color="blue" tag size="medium">
                        {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                      </Label>
                    )}

                  <Header as="h4" color="blue" content="Ingresa el importe" />
                  <Field
                    name="importe"
                    component={NumberInput}
                    placeholder="Ingresa el importe"
                    handleOnChange={(value) => {
                      setImporteTransferencia(Number(value));
                    }}
                    maxLength={LONGITUD_MAXIMA_IMPORTE}
                    disabled={!cuentaOrigen}
                  />
                  <Container textAlign="center">
                    <Button
                      content="Continuar"
                      disabled={invalid}
                      loading={submitting}
                      style={{ minWidth: "12em", maxWidth: "15em" }}
                      color="yellow"
                      size="large"
                    />
                  </Container>
                </Form>
              )}
            />
          </>
        ) : faseTransferenciaCuentasPropias ===
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_VALIDACION ? (
          <>
            <TransferenciasCuentasPropiasHeader />
            <DisponibilidadOperacionesMessage />
            <Header
              as="h4"
              color="blue"
              content="Revisa los datos y confirma la transferencia"
            />
            <TransferenciasCuentasPropiasResumen
              cuentaOrigen={cuentaOrigen}
              cuentaDestino={cuentaDestino}
              aplicaTipoCambio={aplicaTipoCambio}
              tipoCambio={tipoCambioValidado}
              itfTransferencia={itfValidado}
              codigoMonedaTransferencia={codigoMoneda}
              importeTotalTransferir={importeTransferencia}
              importeValidado={importeValidado}
              importeDebitarValidado={importeDebitarValidado}
              monedaDebitarValidado={monedaDebitarValidado}
              importeTransferirValidado={importeTransferirValidado}
              monedaTransferirValidado={monedaTransferirValidado}
            />
            <br />
            <Grid>
              <Grid.Row>
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  <Button
                    fluid
                    content="Atrás"
                    color="blue"
                    size="large"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAtras();
                    }}
                  />
                </Grid.Column>
                <Grid.Column
                  computer={8}
                  largeScreen={8}
                  mobile={2}
                  tablet={4}
                />
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  <Button
                    content="Confirmar"
                    onClick={submitConfirmarTransferencia}
                    fluid
                    color="yellow"
                    size="large"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </>
        ) : (
          <>
            <Container style={{ width: "65%" }} textAlign="center">
              <br />
              <Icon name="check circle outline" color="yellow" size="huge" />
              <Header as="h1" color="blue" size="huge">
                Se realizó exitosamente tu transferencia
              </Header>
              <Header as="h4" color="blue" size="tiny">
                Te enviamos un correo con el detalle de la transferencia.
              </Header>
              <TransferenciasCuentasPropiasResumen
                cuentaOrigen={cuentaOrigen}
                cuentaDestino={cuentaDestino}
                aplicaTipoCambio={aplicaTipoCambio}
                tipoCambio={tipoCambioValidado}
                itfTransferencia={itfValidado}
                codigoMonedaTransferencia={codigoMoneda}
                importeTotalTransferir={importeTransferencia}
                importeValidado={importeValidado}
                transferenciaExitosa={true}
                importeDebitarValidado={importeDebitarValidado}
                monedaDebitarValidado={monedaDebitarValidado}
                importeTransferirValidado={importeTransferirValidado}
                monedaTransferirValidado={monedaTransferirValidado}
              />
              <br />
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                  >
                    <Button
                      as={Link}
                      to="/transferencias"
                      color="blue"
                      fluid
                      size="large"
                      content="Nueva transferencia"
                    />
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                    textAlign="right"
                  >
                    <Button
                      to="/cuentas"
                      as={Link}
                      color="yellow"
                      size="large"
                      fluid
                      content="Ir a mis cuentas"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </>
        )}
      </Container>
    </>
  );
};
TransferenciasCuentasPropiasPage.propTypes = {
  cuentasOperaciones: PropTypes.array.isRequired,
  loadingCuentasOperaciones: PropTypes.bool.isRequired,
  loadingCuentasDeposito: PropTypes.bool.isRequired,
  getCuentasOperaciones: PropTypes.func.isRequired,
  getCuentasDeposito: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
  transferenciaCuentasPropiasValidar: PropTypes.func.isRequired,
  transferenciaCuentasPropiasConfirmar: PropTypes.func.isRequired,
  loadingTransferenciaCuentasPropiasValidar: PropTypes.bool.isRequired,
  loadingTransferenciaCuentasPropiasConfirmar: PropTypes.bool.isRequired,
};
export default connect(mapState, actions)(TransferenciasCuentasPropiasPage);
